import { render } from "./Step_vn_diagnosisView.vue?vue&type=template&id=074550e6"
import script from "./Step_vn_diagnosisView.vue?vue&type=script&lang=js"
export * from "./Step_vn_diagnosisView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__